<script lang="ts" setup>
  import { storeToRefs } from 'pinia';

  import { type Partner } from '~/types/ecommerce/generated.codegen';

  const userStore = useUserStore();
  const { user } = storeToRefs(userStore);
  const currentStep = ref<number>(0);
  provide('currentStep', currentStep);
</script>

<template>
  <main id="app-ecommerce-checkout" class="app-ecommerce-checkout">
    <HeaderCheckout show-step />
    <SharedWholesalerAlert v-if="userStore.isWholesaler" />
    <SharedImpersonateAlert :user="user as Partner" />
    <section class="page">
      <NuxtPage />
    </section>
    <Footer />
  </main>
</template>

<style lang="scss">
  .app-ecommerce-checkout {
    @apply flex flex-col min-h-screen;

    > .page {
      @apply flex-1;
      @apply bg-neutral-high-light;
    }
  }
</style>
